import Vue from 'vue';
import Component from 'vue-class-component';
import {EnvironmentBar} from './environment-bar';
import {Footer} from './footer';
import {AuthorisationManager, Identity, TableHeader, Icon} from 'wc-lib';
import {Service} from '../service';

require('../../icons/error.svg');

@Component({
  template: require('./change-password.html'),
  components: {
    'environment-bar': EnvironmentBar,
    'aemo-footer': Footer,
    'wc-icon': Icon
  }
})
export class ChangePassword extends Vue {
  oldPassword: string = '';
  password: string = '';
  confirmPassword: string = '';
  error: string = null;
  //error: string = 'Login failed after password change. Please try logging in again';
  success: boolean = false;
  inputOldPasswordError: string = null;
  inputNewPasswordError: string = null;
  inputConfirmPasswordError: string = null;

  async changePassword() {
    this.error = null;
    let validated = this.validateOldPassword() && this.validateNewPassword() && this.validateConfirmPassword();
    
    if (validated) {
      let response = await Service.changePassword(this.oldPassword, this.password);
      if (response.Success) {
        let identity;
        let aemoSession = localStorage.getItem('aemo-session');
        if (aemoSession) {
          identity = JSON.parse(localStorage.getItem('aemo-session')) as Identity;
          identity = await Service.authenticate(identity.UserId, this.password)
        }

        if (identity.UserId && !identity.PasswordReset) {
          localStorage.setItem('aemo-session', JSON.stringify(identity));

          if (!AuthorisationManager.getParticipant()) {
            AuthorisationManager.setParticipant(identity.PrimaryParticipantId, identity.PrimaryParticipantName);
          }
          this.success = true;
        } else {
          this.error = 'Login failed after password change. Please try logging in again';
        }
      } else {
        this.error = response.Message;
      }
    }
  }

  validateOldPassword(): boolean {
    this.inputOldPasswordError = null;
    if (!this.oldPassword) {
      this.inputOldPasswordError = 'The current password field is required.';
      return false;
    }

    return true;
  }

  validateNewPassword(): boolean {
    this.inputNewPasswordError = null;
    if (!this.password) {
      this.inputNewPasswordError = 'The new password field is required.';
      return false;
    }

    return true;
  }

  validateConfirmPassword(): boolean {
    this.inputConfirmPasswordError = null;
    if (!this.confirmPassword) {
      this.inputConfirmPasswordError = 'The confirm password field is required.';
      return false;
    } else if (this.password !== this.confirmPassword) {
      this.inputConfirmPasswordError = 'Passwords do not match.';
      return false;
    } 

    return true;
  }
}



// WEBPACK FOOTER //
// src/views/change-password.ts